import axios from 'axios';
import * as types from './Recovery.types';

const REQUEST_TIMEOUT = 15000;
const BASE_URL = 'https://sistemas.udea.edu.co/api/ldap/recovery';

const GENERIC_ERROR = 'El código ingresado no es válido o expiró';
const UNAVAILABLE_ERROR = 'En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.';

function extractMessage(error: unknown): string {
  if (axios.isAxiosError(error) && error.response?.data?.message) {
    return error.response.data.message;
  }
  return UNAVAILABLE_ERROR;
}

export const verifyTotpService = async (username: string, code: string): Promise<types.VerifyRecoveryResponse> => {
  try {
    const { data } = await axios.post<types.VerifyRecoveryResponse>(
      `${BASE_URL}/totp/verify`,
      { username, code },
      { timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) throw new Error(GENERIC_ERROR);
    throw new Error(extractMessage(error));
  }
};

export const verifyRecoveryCodeService = async (username: string, code: string): Promise<types.VerifyRecoveryResponse> => {
  try {
    const { data } = await axios.post<types.VerifyRecoveryResponse>(
      `${BASE_URL}/codes/verify`,
      { username, code },
      { timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) throw new Error(GENERIC_ERROR);
    throw new Error(extractMessage(error));
  }
};

export const verifyAdminTicketService = async (username: string, ticket: string): Promise<types.VerifyRecoveryResponse> => {
  try {
    const { data } = await axios.post<types.VerifyRecoveryResponse>(
      `${BASE_URL}/admin/ticket/verify`,
      { username, ticket },
      { timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) throw new Error(GENERIC_ERROR);
    throw new Error(extractMessage(error));
  }
};

export const totpSetupService = async (token: string): Promise<types.TotpSetupResponse> => {
  try {
    const { data } = await axios.post<types.TotpSetupResponse>(
      `${BASE_URL}/totp/setup`,
      {},
      { headers: { Authorization: `Bearer ${token}` }, timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    throw new Error(UNAVAILABLE_ERROR);
  }
};

export const totpConfirmService = async (token: string, code: string): Promise<types.TotpConfirmResponse> => {
  try {
    const { data } = await axios.post<types.TotpConfirmResponse>(
      `${BASE_URL}/totp/confirm`,
      { code },
      { headers: { Authorization: `Bearer ${token}` }, timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.message) throw new Error(error.response.data.message);
    throw new Error(UNAVAILABLE_ERROR);
  }
};

export const regenerateRecoveryCodesService = async (token: string): Promise<types.TotpConfirmResponse> => {
  try {
    const { data } = await axios.post<types.TotpConfirmResponse>(
      `${BASE_URL}/codes/regenerate`,
      {},
      { headers: { Authorization: `Bearer ${token}` }, timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    throw new Error(UNAVAILABLE_ERROR);
  }
};

export const issueAdminTicketService = async (token: string, username: string): Promise<types.AdminTicketResponse> => {
  try {
    const { data } = await axios.post<types.AdminTicketResponse>(
      `${BASE_URL}/admin/ticket`,
      { username },
      { headers: { Authorization: `Bearer ${token}` }, timeout: REQUEST_TIMEOUT }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 403) throw new Error('No estás autorizado para esta acción');
    throw new Error(UNAVAILABLE_ERROR);
  }
};
